<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/new-certification/detail/'+certification?.id">chevron_left</mat-icon>
            <h1 class="page-title">Edit Certification</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification'">Certifications</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification/detail/'+certification?.id">{{certification?.certificationTitle}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Edit</span>
        </div>
    </div>

    <hr class="mb-3" />

    <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
        <div class="row">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Title</mat-label>
                    <input type="text" matInput formControlName="certificationTitle">
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2 ">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Association</mat-label>
                    <mat-select formControlName="providerId">
                        <mat-option *ngFor="let assoc of associations" [value]="assoc.id">
                            {{ assoc.providerName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>CEU Required</mat-label>
                    <span matSuffix style="margin-right: 10px;">CEU</span>
                    <input style="padding-top: 3px;" class="text-end" type="number" matInput formControlName="ceuRequired">
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Duration</mat-label>
                    <span matSuffix style="margin-right: 10px;">Year</span>
                    <input style="padding-top: 3px;" class="text-end" (change)="changeDurationInMonths()" type="number" matInput formControlName="duration">
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Price</mat-label>
                    <span matPrefix style="margin-left: 10px;">$</span>
                    <input style="padding-top: 3px;" class="text-end" type="number" matInput formControlName="price">
                </mat-form-field>

            </div>
        </div>

        <mat-label class="text-color-black-normal-50">Attendance Type</mat-label>

        <div class="card-bg-20 rounded-2 p-3 mt-2 mb-4">
            <div *ngFor="let at of attendanceTypes.parameterMembers; let x = index">
                <mat-checkbox
                        (change)="addRemoveAttendanceType($event, at.parameterValue, at.parameterLabel)"
                        [value]="at.parameterValue"
                        [checked]="checkCheckedAttendanceType(at.parameterValue)"
                    >
                    {{at.parameterLabel}}
                </mat-checkbox>
            </div>

        </div>

        <mat-label class="text-color-black-normal-50">Certification Condition</mat-label>
        <app-certification-condition-check-list
                [form]="form"
                [certification]="certification"
                [conditions]="conditions"
                [mode]="'edit'"
                (activityChecked)="addRemoveActivity($event)">
        </app-certification-condition-check-list>


        <div class="row my-5">
            <div class="col-12 text-end">
                <button mat-raised-button class="edit-button" (click)="saveCertification()">Save</button>
            </div>
        </div>
    </form>
</div>

